import { Play } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const StartIcon = DeckardIconWrapper({ Icon: Play });
